import React, { useEffect, useState } from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "./UsageIcon.scss";

const UsageIcon = ({ onClick }) => {
  const [usagePercentage, setUsagePercentage] = useState(0);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchUsage();
  }, []);

  const fetchUsage = async () => {
    try {
      const token = localStorage.getItem("admin-token");
      const usageType = "ai_spend";

      const url = `${process.env.REACT_APP_API_URL}/api/config/usage?type=${usageType}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          accept: "application/json",
          authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch usage. Status: ${response.status}`);
      }

      const result = await response.json();
      if (!result.success) {
        setError(result.message || "No usage data found.");
        return;
      }

      const usageArray = result.data.usages;
      if (!usageArray || usageArray.length === 0) {
        setError("No usage data returned.");
        return;
      }

      const { value, quota } = usageArray[0];
      const percent = quota > 0 ? (value / quota) * 100 : 0;
      setUsagePercentage(percent);
    } catch (err) {
      console.error("Error fetching usage:", err);
      setError("Error fetching usage.");
    }
  };

  const getPathColor = (percentage) => {
    if (percentage < 50) return "green";
    if (percentage < 75) return "yellow";
    return "red";
  };

  return (
    <button className="usage-icon" onClick={onClick} title="Ver uso (Botpress)">
      {error ? (
        <span title={error}>!</span>
      ) : (
        <>
          <CircularProgressbar
            value={usagePercentage}
            text={""} 
            styles={buildStyles({
              pathColor: getPathColor(usagePercentage),
              trailColor: "#d6d6d6",
            })}
          />
        </>
      )}
    </button>
  );
};

export default UsageIcon;
